const arrayWrap = value => {
  if (value === undefined) return [];
  return value instanceof Array ? value : [ value ];
};

export default arrayWrap;
